import * as React from 'react';

export enum LoadingSize {
	DEFAULT = 'default',
	SMALL = 'small',
}

interface LoadingProps {
	absolute?: boolean;
	size?: LoadingSize;
}

const Loading: React.FC<LoadingProps> = ({
	absolute,
	size = LoadingSize.DEFAULT,
}) => {

	const loader = (
		<div className='sk-chase' style={{margin: 0}}>
			{[...Array(6)].map((x, i) => (
				<div className={`sk-chase-dot`} key={i} />
			))}
		</div>
	);

	if (size === LoadingSize.SMALL) {
		return (
			<div
				className='sk-chase'
				style={{ height: '25px', width: '25px', margin: 0 }}
			>
				{[...Array(6)].map((_, i) => (
					<div className={`sk-chase-dot`} key={i} />
				))}
			</div>
		);
	}

	if (absolute) {
		return (
			<div
				style={{
					position: 'absolute',
					left: 0,
					right: 0,
					top: 0,
					bottom: 0,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					backgroundColor: 'rgba(255,255,255,.6)',
				}}
			>
				{loader}
			</div>
		);
	}

	return loader;
};

export default Loading;
